import React, { Component } from 'react';
import FlipNumbers from 'react-flip-numbers';
import { jsx, css } from '@emotion/core';
import moment from 'moment';

import './CountDown.scss';

const Digit = ({ digit, unit, primaryColor, uiVariantCountdown }) => {
  const digitStyle = css`
    &.variant-1 {
      & > div {
        color: #fff;
        background-color: ${primaryColor};
        border-radius: 10px;
      }
    }

    &.variant-2 {
      & > div {
        color: #fff;
        background-color: ${primaryColor};
      }
    }

    &.variant-3 {
      & > div {
        color: #4f4f4f;
        background-color: #fff;
        border: 1px solid ${primaryColor};
      }
    }
  `;

  return (
    <div className={`digit variant-${uiVariantCountdown}`} css={digitStyle}>
      <div>
        <FlipNumbers
          play
          background={uiVariantCountdown === '3' ? '#fff' : primaryColor}
          color={uiVariantCountdown === '3' ? '#4f4f4f' : '#fff'}
          width={25}
          height={30}
          numbers={digit <= 9 ? `0${digit}` : `${digit}`}
        />
      </div>
      {unit.toUpperCase()}
    </div>
  );
};

class CountDown extends Component {
  constructor(props) {
    super(props);

    const { timeEnd } = props;

    const deadline = moment(timeEnd, 'YYYY-MM-DD', true).endOf('day');
    const milliseconds = deadline.diff(moment(), 'milliseconds');
    const days = Math.floor(moment.duration(milliseconds).asDays());
    const hours = moment.duration(milliseconds).hours();
    const minutes = moment.duration(milliseconds).minutes();
    const seconds = moment.duration(milliseconds).seconds();

    this.state = {
      time: [days, hours, minutes, seconds],
    };
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      const { timeEnd } = this.props;
      const deadline = moment(timeEnd, 'YYYY-MM-DD', true).endOf('day');
      const milliseconds = deadline.diff(moment(), 'milliseconds');
      const days = Math.floor(moment.duration(milliseconds).asDays());
      const hours = moment.duration(milliseconds).hours();
      const minutes = moment.duration(milliseconds).minutes();
      const seconds = moment.duration(milliseconds).seconds();
      this.setState({ time: [days, hours, minutes, seconds] });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    const { time } = this.state;
    const { timeEnd, primaryColor, uiVariantCountdown } = this.props;

    const today = moment();
    const deadline = moment(timeEnd, 'YYYY-MM-DD', true);

    return deadline.isBefore(today) ? (
      <h2>Offerta scaduta</h2>
    ) : (
      <div className="count-down">
        <Digit
          digit={time[0]}
          unit="Giorni"
          primaryColor={primaryColor}
          uiVariantCountdown={uiVariantCountdown}
        />
        <Digit
          digit={time[1]}
          unit="Ore"
          primaryColor={primaryColor}
          uiVariantCountdown={uiVariantCountdown}
        />
        <Digit
          digit={time[2]}
          unit="Minuti"
          primaryColor={primaryColor}
          uiVariantCountdown={uiVariantCountdown}
        />
        <Digit
          digit={time[3]}
          unit="Secondi"
          primaryColor={primaryColor}
          uiVariantCountdown={uiVariantCountdown}
        />
      </div>
    );
  }
}

export default CountDown;
